export default __webpack_public_path__ + "static/Natural_Light_Outdoor-05acd4a1979e6c4d95a81358ed6fafa6.avif";